<template>
    <div :class="['sub_contents', 'join_glass_page', { 'standalone-page': isStandalonePage }]">
        <div class="cont_center join_glass_center">
            <div class="login_box_area join_glass_card">
                <div class="login_input_area">
                    <div class="form_intro_header">
                        <h2 class="title_page title_page_badge">회원 가입</h2>
                    </div>
                    <ul class="login_input_list">
                        <li>
                            <h3 class="title_input">이름 <span class="required_star">*</span></h3>
                            <p class="member_name">{{ userData.USER_NAME }}</p>
                        </li>
                        <li>
                            <h3 class="title_input">연락처 <span class="required_star">*</span></h3>
                            <InputText v-model="userMobile" :placeholder="placeholderMobile" id="mobile" disabled
                                readonly />
                        </li>
                        <li>
                            <h3 class="title_input">이메일 <span class="required_star">*</span></h3>
                            <div class="email_area_stacked">
                                <div class="email_input_row">
                                    <InputText v-model="emailId" id="email1" :disabled="isEmailReadonly"
                                        :readonly="isEmailReadonly" />
                                    <span class="email_at">@</span>
                                    <InputText v-model="emailDomain" id="email2" :disabled="isEmailReadonly"
                                        :readonly="isEmailReadonly" />
                                </div>
                            </div>
                        </li>
                        <li class="no_required">
                            <h3 class="title_input">부가정보 <span class="input_optional">(선택)</span></h3>
                            <div class="optional_info_panel">
                                <div class="optional_info_item">
                                    <p class="optional_info_label">생년월일</p>
                                    <InputText v-model="birthInput" id="birthInput" placeholder="YYYYMMDD (예: 19900131)"
                                        @update:modelValue="handleBirthInput" @blur="handleBirthBlur" />
                                    <p class="optional_info_notice optional_info_notice_birth"><span
                                            class="required_star">*</span>숫자 8자리로 입력해 주세요.
                                    </p>
                                </div>

                                <div class="optional_info_item optional_info_item_gender">
                                    <p class="optional_info_label">성별</p>
                                    <div class="gender_select_area">
                                        <RadioBox v-for="option in genderOption" :key="option.id" :id="option.id"
                                            :name="radioGroupName" :value="option.value" :label="option.label"
                                            v-model="genderValues" />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="btn_login_area outside_action">
                <a href="#" to="/HFO_MB_005" class="btn_type2" @click.prevent="handleJoin()">확인</a>
            </div>
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" title="알림">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import InputText from '@/components/InputText'
import RadioBox from '@/components/RadioBox'
import AlertPopup from '@/components/AlertPopup.vue';
import { nextTick } from 'vue';
import { postAxios } from '@/lib/AxiosCall';
import { useRoute, useRouter } from 'vue-router';
import { encryptAES256, safeDecrypt } from '@/lib/crypto';
import { getConfig } from '@/lib/Config';

export default {
    components: {
        InputText,
        RadioBox,
        AlertPopup
    },
    data() {
        return {
            placeholderId: 'ID',
            placeholderEmail: '이메일을 입력하세요.',
            placeholderMobile: '연락처를 입력하세요. (예: 010-1234-5678)',
            placeholderPw: '영문, 숫자, 특수문자 8~16자 이내 입력',
            placeholderPwCk: '확인을 위해 한번 더 입력해 주세요.',
            birthInput: '',
            emailId: '',
            emailDomain: '',
            userMobile: '',
            genderOption: [
                { id: 'M', label: '남성', value: 'M', checked: false },
                { id: 'F', label: '여성', value: 'F', checked: false },
                { id: 'NONE', label: '선택안함', value: '', checked: true }
            ],
            radioGroupName: 'gender',
            genderValues: '',
            isEmailReadonly: false,
            alertRequiredShow: false,
            alertContent: '',
            foodconEntUuid: '',
            foodconFrcUuid: '',
            isStandalonePage: false,
            previousBodyOverflow: '',
            previousHtmlOverflow: '',
            isOverflowLocked: false,
            autoJoinAttempted: false,
            isJoinSubmitting: false,
        }
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const userData = JSON.parse(sessionStorage.getItem('userData')) || {};

        let termsChecked = sessionStorage.getItem('termsChecked');
        if (termsChecked == 'true') { termsChecked = 'Y' } else { termsChecked = 'N' }
        let privacyChecked = sessionStorage.getItem('privacyChecked');
        if (privacyChecked == 'true') { privacyChecked = 'Y' } else { privacyChecked = 'N' }
        let ecommChecked = sessionStorage.getItem('ecommChecked');
        if (ecommChecked == 'true') { ecommChecked = 'Y' } else { ecommChecked = 'N' }
        let emailChecked = sessionStorage.getItem('emailChecked');
        if (emailChecked == 'true') { emailChecked = 'Y' } else { emailChecked = 'N' }
        let smsChecked = sessionStorage.getItem('smsChecked');
        if (smsChecked == 'true') { smsChecked = 'Y' } else { smsChecked = 'N' }

        return { userData, route, router, termsChecked, privacyChecked, ecommChecked, emailChecked, smsChecked };
    },
    mounted() {
        try {
            this.isStandalonePage = !(window.opener && !window.opener.closed);
        } catch (e) {
            this.isStandalonePage = true;
        }

        const isDesktopViewport = typeof window !== 'undefined' ? window.innerWidth >= 1024 : false;
        if (this.isStandalonePage && isDesktopViewport && typeof document !== 'undefined') {
            this.previousBodyOverflow = document.body.style.overflow || '';
            this.previousHtmlOverflow = document.documentElement.style.overflow || '';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            this.isOverflowLocked = true;
        }

        const queryEntUuid = this.route?.query?.entUuid || '';
        const queryFrcUuid = this.route?.query?.frcUuid || '';
        // 테넌트 회원가입은 진입 URL에 명시된 식별자만 사용한다.
        // 이전 푸드콘 흐름에서 남은 sessionStorage 값은 일반 하이비타민 가입에 전달하지 않는다.
        this.foodconEntUuid = typeof queryEntUuid === 'string' ? queryEntUuid : '';
        this.foodconFrcUuid = typeof queryFrcUuid === 'string' ? queryFrcUuid : '';

        // 이메일 정보 설정 (암호화된 데이터면 복호화)
        if (this.userData && this.userData.USER_EMAIL) {
            try {
                const decryptedEmail = safeDecrypt(this.userData.USER_EMAIL);
                const tmpEmail = decryptedEmail.split("@");
                this.emailId = tmpEmail[0] || '';
                this.emailDomain = tmpEmail[1] || '';
                this.isEmailReadonly = (this.userData?.USER_IN_TYPE || '') === 'USER_IN_KAKAO' && Boolean(this.emailId && this.emailDomain);
            } catch (e) { /* noop */ }
        }

        // 핸드폰 번호 정보 설정 및 포맷팅 (암호화된 데이터면 복호화)
        if (this.userData && this.userData.USER_MOBILE) {
            try {
                const decryptedMobile = safeDecrypt(this.userData.USER_MOBILE);
                this.userMobile = this.formatPhoneForDisplay(decryptedMobile);
            } catch (e) { /* noop */ }
        }

        this.schedulePopupResize();
        window.addEventListener('resize', this.notifyPopupContentSize);
        this.tryAutoJoinForFoodconTarget();

    },
    beforeUnmount() {
        window.removeEventListener('resize', this.notifyPopupContentSize);
        if (this.isOverflowLocked && typeof document !== 'undefined') {
            document.body.style.overflow = this.previousBodyOverflow || '';
            document.documentElement.style.overflow = this.previousHtmlOverflow || '';
        }
    },
    methods: {
        redirectToCpsTargetIfExists() {
            try {
                const raw = sessionStorage.getItem('cps_entry_context') || localStorage.getItem('cps_entry_context');
                const cpsContext = raw ? JSON.parse(raw) : null;
                const targetUrl = cpsContext?.targetUrl || (typeof this.route?.query?.targetUrl === 'string' ? this.route.query.targetUrl : '');
                if (!targetUrl) return false;

                let finalUrl = targetUrl;
                const ci = cpsContext?.ci || (typeof this.route?.query?.ci === 'string' ? this.route.query.ci : '');
                if (ci) {
                    try {
                        const parsed = new URL(finalUrl);
                        parsed.searchParams.set('ci', ci);
                        finalUrl = parsed.toString();
                    } catch (_e) {
                        // ignore malformed URL and fallback to original
                    }
                }

                try {
                    if (window && window.opener && !window.opener.closed) {
                        window.opener.location.href = finalUrl;
                        sessionStorage.removeItem('cps_entry_context');
                        localStorage.removeItem('cps_entry_context');
                        window.close();
                        return true;
                    }
                } catch (_e) {
                    // opener 접근 실패 시 현재 창 이동으로 폴백
                }

                sessionStorage.removeItem('cps_entry_context');
                localStorage.removeItem('cps_entry_context');
                window.location.href = finalUrl;
                return true;
            } catch (_e) {
                return false;
            }
        },

        notifyPopupContentSize() {
            try {
                const body = document.body;
                const html = document.documentElement;
                const frameWidth = Math.max(0, (window.outerWidth || 0) - (window.innerWidth || 0));
                const frameHeight = Math.max(0, (window.outerHeight || 0) - (window.innerHeight || 0));
                const verticalSafetyGap = 8;

                // Viewport가 아니라 실제 폼 컨텐츠 높이를 기준으로 팝업 사이즈를 계산한다.
                const contentRoot = document.querySelector('.join_glass_center')
                    || document.querySelector('.cont_center')
                    || document.querySelector('.login_box_area');

                let contentWidth = 0;
                let contentHeight = 0;

                if (contentRoot && typeof contentRoot.getBoundingClientRect === 'function') {
                    const rect = contentRoot.getBoundingClientRect();
                    contentWidth = Math.ceil(rect.width);
                    contentHeight = Math.ceil(rect.height);
                } else {
                    contentWidth = Math.max(
                        body?.scrollWidth || 0,
                        body?.offsetWidth || 0,
                        html?.scrollWidth || 0,
                        html?.offsetWidth || 0
                    );
                    contentHeight = Math.max(
                        body?.scrollHeight || 0,
                        body?.offsetHeight || 0,
                        html?.scrollHeight || 0,
                        html?.offsetHeight || 0
                    );
                }

                const screenAvailW = window.screen?.availWidth || window.innerWidth || 560;
                const screenAvailH = window.screen?.availHeight || window.innerHeight || 920;
                const maxWidth = Math.max(420, Math.min(560, screenAvailW - 24));
                const maxHeight = Math.max(520, Math.min(900, screenAvailH - 24));
                const minWidth = Math.min(420, maxWidth);
                const isPopupWindow = !!(window.opener && !window.opener.closed);
                const minHeightBase = isPopupWindow ? 520 : 620;
                const minHeight = Math.min(minHeightBase, maxHeight);
                const requestedWidth = Math.ceil(contentWidth) + frameWidth + 8;
                const requestedHeight = Math.ceil(contentHeight) + frameHeight + verticalSafetyGap;
                const safeWidth = Math.max(minWidth, Math.min(maxWidth, requestedWidth));
                const safeHeight = Math.max(minHeight, Math.min(maxHeight, requestedHeight));
                const payload = { type: 'HVM_POPUP_CONTENT_SIZE', width: safeWidth, height: safeHeight };

                if (window.opener && !window.opener.closed) {
                    window.opener.postMessage(payload, '*');
                } else if (window.parent && window.parent !== window) {
                    window.parent.postMessage(payload, '*');
                }
            } catch (error) {
                console.warn('MB_004_SNS popup size notify failed', error);
            }
        },

        schedulePopupResize() {
            nextTick(() => {
                this.notifyPopupContentSize();
                setTimeout(() => this.notifyPopupContentSize(), 120);
                setTimeout(() => this.notifyPopupContentSize(), 320);
                setTimeout(() => this.notifyPopupContentSize(), 700);
            });
        },

        isNaverSignupUser() {
            return (this.userData?.USER_IN_TYPE || '') === 'USER_IN_NAVER';
        },

        async buildSignupConsentFlags() {
            const defaultFlags = {
                agreementYn: this.termsChecked,
                privacyYn: this.privacyChecked,
                commerceYn: this.ecommChecked,
                emailYn: this.emailChecked,
                smsYn: this.smsChecked,
            };

            const isKakaoUser = (this.userData?.USER_IN_TYPE || '') === 'USER_IN_KAKAO';
            if (!isKakaoUser) return defaultFlags;

            try {
                if (typeof window.Kakao === 'undefined' || !window.Kakao?.Auth || !window.Kakao?.API) {
                    return defaultFlags;
                }

                const kakaoToken = sessionStorage.getItem('kakao_access_token') || '';
                if (!kakaoToken) return defaultFlags;

                window.Kakao.Auth.setAccessToken(kakaoToken);

                const result = await window.Kakao.API.request({ url: '/v2/user/service_terms' });
                const terms = Array.isArray(result?.service_terms)
                    ? result.service_terms
                    : (Array.isArray(result?.allowed_service_terms) ? result.allowed_service_terms : []);

                sessionStorage.setItem('kakaoServiceTermsRaw', JSON.stringify(terms));

                const hasAgreedTerm = terms.some((term) => term?.agreed === true);
                const hasMarketingTerm = terms.some((term) => {
                    const agreed = term?.agreed === true;
                    const tag = String(term?.tag || '').toLowerCase();
                    return agreed && (tag.includes('marketing') || tag.includes('benefit') || tag.includes('channel') || tag.includes('email') || tag.includes('sms') || tag.includes('ad'));
                });

                const agreedYn = hasAgreedTerm ? 'Y' : 'N';
                const marketingYn = (hasMarketingTerm || hasAgreedTerm) ? 'Y' : 'N';

                return {
                    agreementYn: agreedYn,
                    privacyYn: agreedYn,
                    commerceYn: agreedYn,
                    emailYn: marketingYn,
                    smsYn: marketingYn,
                };
            } catch (error) {
                console.warn('MB_004_SNS: service_terms 조회 실패, 기본 동의값 사용', error);
                return defaultFlags;
            }
        },

        // 국가코드 제거 및 한국 번호로 변환
        normalizePhoneNumber(phoneNumber) {
            if (!phoneNumber) return '';
            let cleanNumber = phoneNumber.replace(/\s/g, '');
            if (cleanNumber.startsWith('+82')) {
                cleanNumber = cleanNumber.substring(3);
                if (!cleanNumber.startsWith('0')) cleanNumber = '0' + cleanNumber;
            } else if (cleanNumber.startsWith('82') && cleanNumber.length > 10) {
                cleanNumber = cleanNumber.substring(2);
                if (!cleanNumber.startsWith('0')) cleanNumber = '0' + cleanNumber;
            }
            return cleanNumber;
        },

        // 화면 표시용 포맷팅 (하이픈 포함)
        formatPhoneForDisplay(phoneNumber) {
            const normalized = this.normalizePhoneNumber(phoneNumber);
            const numbers = normalized.replace(/[^0-9]/g, '');
            if (numbers.length === 11) return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            if (numbers.length === 10) return numbers.startsWith('02') ? numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3') : numbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            return normalized;
        },

        // API 전송용 숫자만 추출
        getCleanPhoneNumber(phoneNumber) { return this.normalizePhoneNumber(phoneNumber || '').replace(/[^0-9]/g, ''); },

        handleBirthInput(inputValue) {
            const digitsOnly = String(inputValue || '').replace(/[^0-9]/g, '').slice(0, 8);
            this.birthInput = digitsOnly;
        },

        handleBirthBlur() {
            const normalizedBirth = this.getNormalizedBirthDate();
            if (normalizedBirth) {
                this.birthInput = normalizedBirth;
            }
        },

        getNormalizedBirthDate() {
            const birthDigits = String(this.birthInput || '').replace(/[^0-9]/g, '');
            if (!birthDigits) {
                return '';
            }
            if (birthDigits.length !== 8) {
                return null;
            }

            const year = Number(birthDigits.slice(0, 4));
            const month = Number(birthDigits.slice(4, 6));
            const day = Number(birthDigits.slice(6, 8));
            const currentYear = new Date().getFullYear();

            if (year < 1900 || year > currentYear || month < 1 || month > 12) {
                return null;
            }

            const maxDay = new Date(year, month, 0).getDate();
            if (day < 1 || day > maxDay) {
                return null;
            }

            return `${birthDigits.slice(0, 4)}-${birthDigits.slice(4, 6)}-${birthDigits.slice(6, 8)}`;
        },

        isValidEmail(userEmail) {
            if (!userEmail) return true;
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail);
        },

        resolveOptionalPlatformParams() {
            let platformUser = '';
            let platformGroup = '';

            try {
                const query = this.route?.query || {};
                const cpsRaw = sessionStorage.getItem('cps_entry_context') || localStorage.getItem('cps_entry_context');
                const cps = cpsRaw ? JSON.parse(cpsRaw) : {};
                const configPlatform = getConfig()?.platform || {};

                // 광고 embed 값 매핑: data-hvm-user-id -> platformUser, data-hvm-sub-id -> platformGroup
                platformUser = String(
                    query.platformUser || query.userId || cps.userId || configPlatform.platformUser || ''
                ).trim();
                platformGroup = String(
                    query.platformGroup || query.subId || cps.subId || configPlatform.platformGroup || ''
                ).trim();
            } catch (_e) {
                platformUser = '';
                platformGroup = '';
            }

            const result = {};
            if (platformUser) result.platformUser = platformUser;
            if (platformGroup) result.platformGroup = platformGroup;
            return result;
        },

        shouldAutoJoinForFoodconTarget() {
            return Boolean(this.foodconEntUuid || this.foodconFrcUuid);
        },

        tryAutoJoinForFoodconTarget() {
            if (!this.shouldAutoJoinForFoodconTarget() || this.autoJoinAttempted) {
                return;
            }
            this.autoJoinAttempted = true;
            nextTick(() => {
                this.handleJoin(true);
            });
        },

        async handleJoin(isAutoJoin = false) {
            if (this.isJoinSubmitting) {
                return;
            }
            this.isJoinSubmitting = true;
            try {
                const cleanMobile = this.getCleanPhoneNumber(this.userMobile || '');
                if (!cleanMobile) {
                    this.alertContent = '연락처를 입력해 주세요.';
                    this.alertRequiredShow = true;
                    return;
                }

                if (!/^01\d{8,9}$/.test(cleanMobile)) {
                    this.alertContent = '연락처 형식이 올바르지 않습니다. (예: 010-1234-5678)';
                    this.alertRequiredShow = true;
                    return;
                }

                const userBirth = this.getNormalizedBirthDate();
                if (userBirth === null) {
                    this.alertContent = '생년월일 형식이 올바르지 않습니다. YYYYMMDD 형태로 입력해 주세요.';
                    this.alertRequiredShow = true;
                    return;
                }

                const emailId = (this.emailId || '').trim();
                const emailDomain = (this.emailDomain || '').trim();
                if (!emailId || !emailDomain) {
                    this.alertContent = this.isEmailReadonly
                        ? '카카오 이메일 정보를 불러오지 못했습니다. 다시 시도해 주세요.'
                        : '이메일을 입력해 주세요.';
                    this.alertRequiredShow = true;
                    return;
                }

                const userEmail = `${emailId}@${emailDomain}`;
                if (!this.isValidEmail(userEmail)) {
                    this.alertContent = '이메일 형식이 올바르지 않습니다.';
                    this.alertRequiredShow = true;
                    return;
                }

                const consentFlags = await this.buildSignupConsentFlags();

                const hvmConfig = getConfig();
                const branchUuid = hvmConfig?.branch?.branchUuid || '';

                const encryptedId = encryptAES256(String(this.userData.USER_ID || ''));
                const encryptedMobile = encryptAES256(cleanMobile);
                const userBirthDigits = userBirth ? userBirth.replace(/-/g, '') : '';
                const encryptedBirth = encryptAES256(userBirthDigits);
                const encryptedEmail = encryptAES256(userEmail);

                const memberPayload = {
                    userId: encryptedId,
                    userMobile: encryptedMobile,
                    userPwd: '',
                    userName: this.userData.USER_NAME || '',
                    userBirth: encryptedBirth,
                    userGender: this.genderValues || '',
                    userEmail: encryptedEmail,
                    agreementYn: consentFlags.agreementYn,
                    privacyYn: consentFlags.privacyYn,
                    commerceYn: consentFlags.commerceYn,
                    emailYn: consentFlags.emailYn,
                    smsYn: consentFlags.smsYn,
                    sttsType: 'USER_MEMBER',
                    userInType: this.userData.USER_IN_TYPE || '',
                    branchUuid: branchUuid
                };

                Object.assign(memberPayload, this.resolveOptionalPlatformParams());

                if (this.foodconEntUuid) {
                    memberPayload.entUuid = this.foodconEntUuid;
                } else if (this.foodconFrcUuid) {
                    memberPayload.frcUuid = this.foodconFrcUuid;
                }

                const response = await postAxios('/bgm/v1/mem/member', memberPayload);

                if (this.isNaverSignupUser()) {
                    sessionStorage.setItem('showKakaoChannelGuideOnJoinComplete', 'Y');
                } else {
                    sessionStorage.removeItem('showKakaoChannelGuideOnJoinComplete');
                }

                if (this.redirectToCpsTargetIfExists()) {
                    return;
                }

                // 가입 성공 후 리다이렉트
                const redirect = this.route.query.redirect || '/HFO_MB_005';
                this.router.push({ path: redirect });
            } catch (error) {
                console.error('회원가입 중 오류가 발생했습니다:', error);
                this.alertContent = isAutoJoin
                    ? '자동 회원가입 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'
                    : '회원가입 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
                this.alertRequiredShow = true;
            } finally {
                this.isJoinSubmitting = false;
            }
        },

        // 기존 메서드들
    }
}
</script>

<style scoped>
.join_title_group {
    margin-bottom: 12px;
    text-align: center;
}

.form_intro_header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px 0 8px;
}

.title_page_badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 8px 18px;
    border-radius: 999px;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #7a5600;
    background: #ffefc2;
}

.join_glass_page {
    min-height: auto;
    padding-bottom: 0;
    box-sizing: border-box;
}

.join_glass_page.standalone-page {
    min-height: 100dvh;
}

.sub_contents.standalone-page {
    padding-top: 18px !important;
    position: relative;
}

.sub_contents.standalone-page::before {
    display: none !important;
}

.sub_contents.standalone-page .cont_center {
    max-width: 760px;
    margin: 0 auto;
    width: 100%;
    padding-right: 0 !important;
    box-sizing: border-box;
}

.sub_contents.standalone-page .login_box_area {
    display: block !important;
    margin: 0 auto !important;
    width: 100% !important;
    min-height: auto !important;
    border: 1px solid #eee !important;
    border-radius: 10px !important;
    box-sizing: border-box;
    overflow: hidden;
}

.sub_contents.standalone-page .login_input_area {
    padding: 24px 20px !important;
    border: none !important;
    box-sizing: border-box;
}

.sub_contents.standalone-page .login_input_list>li {
    padding-bottom: 20px !important;
    position: static !important;
}

.sub_contents.standalone-page .login_input_list>li.no_required {
    padding-bottom: 0 !important;
}

.sub_contents.standalone-page .title_input {
    margin-bottom: 4px !important;
}

.sub_contents.standalone-page .btn_login_area {
    margin-top: 22px !important;
}

.sub_contents {
    padding: 12px 10px 0;
    box-sizing: border-box;
}

.cont_center {
    width: 100%;
    max-width: 540px;
    margin: 0 auto;
    box-sizing: border-box;
}

.title_page {
    font-size: 22px;
    line-height: 1.2;
    margin-bottom: 8px;
}

.login_box_area {
    width: 100%;
    padding: 0;
    box-sizing: border-box;
}

.login_input_list {
    margin-top: 0;
    padding-left: 0;
    padding-right: 0;
    list-style: none;
}

.login_input_list li {
    margin-bottom: 3px !important;
}

.title_input {
    font-size: 14px;
    margin-bottom: 4px;
}

.member_name {
    font-size: 11px;
    line-height: 1.2;
}

.login_input_list li :deep(#mobile[disabled]),
.login_input_list li :deep(#mobile[readonly]),
.login_input_list li :deep(#email1[disabled]),
.login_input_list li :deep(#email1[readonly]),
.login_input_list li :deep(#email2[disabled]),
.login_input_list li :deep(#email2[readonly]) {
    background-color: #f2f2f2 !important;
    -webkit-text-fill-color: #666 !important;
    color: #666 !important;
    opacity: 1 !important;
}

.login_input_area :deep(input) {
    min-height: 38px;
    font-size: 13px;
}

.btn_login_area {
    margin-top: 20px;
}

.btn_login_area.outside_action {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 0;
}

.btn_login_area .btn_type2 {
    display: block;
    width: 100%;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    border-radius: 8px;
}

.btn_login_area.outside_action .btn_type2 {
    max-width: 360px;
}

@media (min-width: 1024px) {
    .join_glass_page.standalone-page {
        min-height: 100dvh;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        background:
            radial-gradient(circle at 12% 15%, rgba(255, 195, 52, 0.2), transparent 34%),
            radial-gradient(circle at 86% 80%, rgba(238, 117, 40, 0.1), transparent 40%),
            linear-gradient(180deg, #fffaf0 0%, #f6f6f6 100%);
    }

    .join_glass_page.standalone-page::after {
        content: "";
        position: absolute;
        inset: 0;
        background-image:
            linear-gradient(rgba(255, 255, 255, 0.14) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.14) 1px, transparent 1px);
        background-size: 28px 28px;
        pointer-events: none;
        z-index: 0;
    }

    .join_glass_page.standalone-page .join_glass_center {
        position: relative;
        z-index: 1;
        max-width: 980px;
        margin: 0 auto;
        padding: 18px 20px 12px;
        min-height: calc(100dvh - 24px);
        display: flex;
        flex-direction: column;
    }

    .join_glass_card {
        border-radius: 22px !important;
        border: 1px solid rgba(255, 255, 255, 0.85) !important;
        background: linear-gradient(145deg, rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.72)) !important;
        box-shadow: 0 24px 58px rgba(0, 0, 0, 0.11);
        backdrop-filter: blur(8px);
    }

    .title_page_badge {
        font-size: 24px;
        padding: 9px 20px;
    }

    .join_glass_page.standalone-page .btn_login_area.outside_action {
        margin-top: auto;
        padding-top: 12px;
        padding-bottom: 6px;
    }
}

.gender_select_area {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
}

.gender_select_area :deep(.d_radio) {
    min-width: 0;
    width: 100%;
}

.gender_select_area :deep(.d_radio input) {
    display: none;
}

.gender_select_area :deep(.d_radio label) {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    background-color: #f2f2f2;
    color: #9f9f9f;
    font-size: 16px;
    font-weight: 500;
    box-sizing: border-box;
}

.gender_select_area :deep(.d_radio input:checked + label) {
    background-color: #565656;
    border-color: #565656;
    color: #fff;
}

.mobile_notice {
    margin-top: 4px;
    font-size: 14px;
    color: #666;
    line-height: 1.3;
}

.required_star {
    color: #ff0000;
    font-weight: bold;
    margin-right: 2px;
}

.input_optional {
    color: #8f8f8f;
    font-size: 12px;
    font-weight: 500;
}

.optional_info_panel {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 10px;
    border: 1px solid #ececec;
    border-radius: 8px;
    background-color: #ffffff;
    box-sizing: border-box;
}

.optional_info_item {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.optional_info_item_gender {
    margin-top: 6px;
    padding-top: 12px;
    border-top: 1px solid #e5e5e5;
}

.optional_info_label {
    font-size: 12px;
    color: #555;
    font-weight: 600;
}

.optional_info_notice {
    font-size: 11px;
    color: #8a8a8a;
    margin-top: 13px;
}

.optional_info_notice_birth {
    display: block;
    margin-top: 0;
    line-height: 1.4;
}

/* 생년월일 영역 스타일 - 한 줄로 배치 */
.birth_select_area {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;
}

.birth_select_item {
    display: block;
    flex: 0 0 120px;
    max-width: 120px;
    width: 120px;
}

.birth_select_item_day {
    width: 120px;
}

/* 이메일 영역 스타일 */
.email_area_stacked {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.email_input_row {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.email_at {
    font-size: 14px;
    color: #333;
    flex-shrink: 0;
}

.email_select_row {
    width: 100%;
}

/* PC 버전 compact */
@media (min-width: 1024px) {
    .birth_select_area {
        align-items: center;
        flex-wrap: nowrap;
        gap: 8px;
    }

    .birth_select_item {
        width: 120px;
        max-width: 120px;
    }

    .birth_select_item_day {
        width: 120px;
    }

    .email_area_stacked {
        max-width: none;
        flex-direction: row;
        align-items: center;
        gap: 8px;
    }

    .email_input_row {
        justify-content: flex-start;
        flex: 1;
        min-width: 0;
    }

    .email_select_row {
        width: 180px;
        flex: 0 0 180px;
    }

    .email_select_row :deep(.select_box) {
        width: 100%;
    }

    .birth_select_item :deep(.select_box) {
        width: 100%;
        min-height: 40px;
    }

    .birth_select_item :deep(.select_box select) {
        width: 100%;
        text-align: center;
        font-size: 14px;
        padding: 8px 10px;
        min-height: 40px;
    }

    .btn_login_area.outside_action .btn_type2 {
        width: 320px;
        max-width: 320px;
        height: 48px;
        line-height: 48px;
        border-radius: 10px;
        font-size: 16px;
    }
}

/* 모바일 버전 스타일 */
@media (max-width: 1023px) {
    .join_glass_page {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .join_glass_page {
        min-height: auto;
        padding-bottom: 0;
    }

    .title_page_badge {
        font-size: 20px;
        padding: 7px 14px;
    }

    .form_intro_header {
        margin-bottom: 6px;
    }

    .sub_contents {
        padding: 10px 8px 0 !important;
    }

    .sub_contents.standalone-page {
        padding: 10px 8px 0 !important;
    }

    .sub_contents .cont_center,
    .sub_contents.standalone-page .cont_center {
        width: 100%;
        max-width: 100%;
        margin-left: auto !important;
        margin-right: auto !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

    .title_page {
        font-size: 20px;
        margin-bottom: 6px;
    }

    .login_box_area {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .sub_contents.standalone-page .login_box_area {
        border-radius: 10px !important;
    }

    .login_input_area,
    .sub_contents.standalone-page .login_input_area {
        padding: 14px 10px !important;
        width: 100%;
        box-sizing: border-box;
    }

    .login_input_list li {
        margin-bottom: 0 !important;
        display: block;
        padding-bottom: 14px !important;
        width: 100%;
        box-sizing: border-box;
    }

    .title_input {
        margin: 0 0 6px;
        font-size: 13px;
        line-height: 1.35;
        padding-top: 0;
        white-space: nowrap;
    }

    .member_name {
        display: flex;
        align-items: center;
        min-height: 36px;
        padding: 0 10px;
        border-radius: 8px;
    }

    .mobile_notice {
        font-size: 12px;
        margin-top: 4px;
    }

    .btn_login_area {
        margin-top: 8px;
    }

    .btn_login_area .btn_type2 {
        height: 42px;
        line-height: 42px;
        font-size: 14px;
        border-radius: 8px;
    }

    .login_input_list li :deep(.input_type1),
    .login_input_list li :deep(.btn_select) {
        height: 38px !important;
        min-height: 38px !important;
        line-height: 38px !important;
        font-size: 13px !important;
    }

    .login_input_list li :deep(.input_type1) {
        padding: 0 10px !important;
    }

    .login_input_list li :deep(.btn_select) {
        padding: 0 42px 0 10px !important;
    }

    .birth_select_area {
        gap: 6px;
    }

    .birth_select_item {
        flex: 1;
        min-width: 0;
        max-width: none;
        width: auto;
    }

    .birth_select_item_day {
        width: auto;
    }

    .email_area_stacked {
        width: 100%;
        gap: 4px;
    }

    .email_input_row {
        width: 100%;
    }

    .email_input_row :deep(.input_type1) {
        flex: 1;
        min-width: 0;
    }

    .email_select_row {
        width: 100%;
    }

    .login_input_list li :deep(.input_type1),
    .login_input_list li :deep(.select_box),
    .login_input_list li :deep(.btn_select) {
        width: 100% !important;
        margin: 0 !important;
        box-sizing: border-box !important;
    }

    .gender_select_area {
        gap: 6px;
    }

    .gender_select_area :deep(.d_radio label) {
        height: 34px;
        line-height: 34px;
        border-radius: 7px;
        font-size: 13px;
    }

    .optional_info_panel {
        gap: 8px;
        padding: 8px;
        border-radius: 8px;
    }

    .optional_info_item {
        gap: 4px;
    }

    .optional_info_item_gender {
        margin-top: 4px;
        padding-top: 10px;
    }

    .optional_info_label {
        font-size: 12px;
    }

    .optional_info_notice {
        font-size: 11px;
    }

    .optional_info_notice_birth {
        margin-top: 0;
    }

    .btn_login_area,
    .sub_contents.standalone-page .btn_login_area {
        margin-top: 14px !important;
    }

    .btn_login_area .btn_type2 {
        width: 100%;
    }

    /* 모바일용 셀렉트박스 스타일 */
    .birth_select_item :deep(.select_box) {
        width: 100%;
        min-height: 38px;
    }

    .birth_select_item :deep(.select_box select) {
        width: 100%;
        text-align: center;
        font-size: 13px;
        padding: 8px 6px;
        min-height: 38px;
    }
}

/* 공통 셀렉트박스 스타일 */
.birth_select_item :deep(.select_box) {
    width: 100%;
}

.birth_select_item :deep(.select_box select) {
    width: 100%;
    text-align: center;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
}

.birth_select_item :deep(#yearList .select_list ul),
.birth_select_item :deep(#monthList .select_list ul),
.birth_select_item :deep(#dayList .select_list ul) {
    max-height: 260px;
    overflow-y: auto;
}

/* standalone PC 보정: 팝업/독립창 폭이 작아도 데스크탑 형태 유지 */
.sub_contents.standalone-page .birth_select_area {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    gap: 8px;
}

.sub_contents.standalone-page .birth_select_item,
.sub_contents.standalone-page .birth_select_item_day {
    width: 120px;
    max-width: 120px;
    min-width: 120px;
}

.sub_contents.standalone-page .btn_login_area.outside_action {
    justify-content: center;
}

.sub_contents.standalone-page .btn_login_area.outside_action .btn_type2 {
    width: 320px;
    max-width: 320px;
    height: 48px;
    line-height: 48px;
    border-radius: 10px;
    font-size: 18px;
}

/* standalone 모바일 보정: 3개 셀렉트가 잘리지 않도록 유동 폭 유지 */
@media (max-width: 1023px) {
    .sub_contents.standalone-page .birth_select_area {
        gap: 6px;
        flex-wrap: nowrap;
    }

    .sub_contents.standalone-page .birth_select_item,
    .sub_contents.standalone-page .birth_select_item_day {
        flex: 1 1 0;
        width: auto;
        min-width: 0;
        max-width: none;
    }
}

/* 폰트 크기 개별 적용: 각 항목별 15px 통일 */
.join_glass_page .title_page_badge,
.join_glass_page .title_input,
.join_glass_page .member_name,
.join_glass_page .mobile_notice,
.join_glass_page .input_optional,
.join_glass_page .optional_info_label,
.join_glass_page .optional_info_notice,
.join_glass_page .email_at,
.join_glass_page .btn_type2,
.join_glass_page :deep(.alert_txt) {
    font-size: 15px !important;
}

.join_glass_page :deep(#mobile.input_type1),
.join_glass_page :deep(#email1.input_type1),
.join_glass_page :deep(#email2.input_type1),
.join_glass_page :deep(#birthInput.input_type1),
.join_glass_page :deep(.gender_select_area .d_radio label) {
    font-size: 15px !important;
}

.join_glass_page :deep(#mobile.input_type1::placeholder),
.join_glass_page :deep(#email1.input_type1::placeholder),
.join_glass_page :deep(#email2.input_type1::placeholder),
.join_glass_page :deep(#birthInput.input_type1::placeholder) {
    font-size: 15px !important;
}

/* 회색 톤 통일 */
.join_glass_page {
    --hvm-gray-text: #666666;
    --hvm-gray-border: #d8d8d8;
    --hvm-gray-bg-soft: #f2f2f2;
    --hvm-gray-bg-strong: #565656;
    --hvm-gender-border: #1f1f1f;
}

.join_glass_page .member_name,
.join_glass_page .mobile_notice,
.join_glass_page .input_optional,
.join_glass_page .optional_info_label,
.join_glass_page .optional_info_notice,
.join_glass_page .email_at {
    color: var(--hvm-gray-text) !important;
}

.join_glass_page .optional_info_panel,
.join_glass_page .optional_info_item_gender,
.join_glass_page :deep(.input_type1),
.join_glass_page :deep(.btn_select),
.join_glass_page :deep(.select_list),
.join_glass_page :deep(.d_radio label) {
    border-color: var(--hvm-gray-border) !important;
}

.join_glass_page :deep(#mobile[disabled]),
.join_glass_page :deep(#mobile[readonly]),
.join_glass_page :deep(#email1[disabled]),
.join_glass_page :deep(#email1[readonly]),
.join_glass_page :deep(#email2[disabled]),
.join_glass_page :deep(#email2[readonly]) {
    background-color: var(--hvm-gray-bg-soft) !important;
}

.join_glass_page :deep(.gender_select_area .d_radio label) {
    background-color: #ffffff !important;
    border-color: var(--hvm-gender-border) !important;
}

.join_glass_page :deep(#mobile[disabled]),
.join_glass_page :deep(#mobile[readonly]),
.join_glass_page :deep(#email1[disabled]),
.join_glass_page :deep(#email1[readonly]),
.join_glass_page :deep(#email2[disabled]),
.join_glass_page :deep(#email2[readonly]) {
    color: var(--hvm-gray-text) !important;
    -webkit-text-fill-color: var(--hvm-gray-text) !important;
    opacity: 1 !important;
}

.join_glass_page :deep(.d_radio input:checked + label) {
    background-color: var(--hvm-gray-bg-strong) !important;
    border-color: var(--hvm-gender-border) !important;
    color: #ffffff !important;
}
</style>